function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88 c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242 C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879 s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", null);
var _ref4 = /*#__PURE__*/React.createElement("g", null);
var _ref5 = /*#__PURE__*/React.createElement("g", null);
var _ref6 = /*#__PURE__*/React.createElement("g", null);
var _ref7 = /*#__PURE__*/React.createElement("g", null);
var _ref8 = /*#__PURE__*/React.createElement("g", null);
var _ref9 = /*#__PURE__*/React.createElement("g", null);
var _ref10 = /*#__PURE__*/React.createElement("g", null);
var _ref11 = /*#__PURE__*/React.createElement("g", null);
var _ref12 = /*#__PURE__*/React.createElement("g", null);
var _ref13 = /*#__PURE__*/React.createElement("g", null);
var _ref14 = /*#__PURE__*/React.createElement("g", null);
var _ref15 = /*#__PURE__*/React.createElement("g", null);
var _ref16 = /*#__PURE__*/React.createElement("g", null);
var _ref17 = /*#__PURE__*/React.createElement("g", null);
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.971 47.971",
    style: {
      enableBackground: "new 0 0 47.971 47.971"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6d76a400995676b5ecf878d5b5a07aca.svg";
export { ForwardRef as ReactComponent };